import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const ServiceDashboardHeader = ({ 
  serviceCode,
  serviceName, 
  icon,
  gradientFrom,
  gradientTo,
  totalReports,
  totalSpent,
  paidUses,
  onCreateNew
}) => {
  const navigate = useNavigate();

  return (
    <div className={`bg-gradient-to-r ${gradientFrom} ${gradientTo} text-white rounded-lg p-8 mb-8`}>
      {/* Service Title with Icon */}
      <div className="text-center mb-8">
        <div className="flex items-center justify-center gap-3 mb-3">
          <span className="text-3xl">{icon}</span>
          <h1 className="text-2xl font-bold text-white">{serviceName}</h1>
        </div>
      </div>

      {/* Metrics Section - Standard Three Counters */}
      <div className="grid grid-cols-3 gap-8 mb-8 text-center">
        {/* Total Reports */}
        <div>
          <div className="text-sm text-white/80 mb-2">Total Reports</div>
          <div className="text-3xl font-bold text-white">{totalReports || 0}</div>
        </div>

        {/* Total Spent */}
        <div>
          <div className="text-sm text-white/80 mb-2">Total Spent</div>
          <div className="text-3xl font-bold text-white">
            ${(totalSpent || 0).toFixed(2)}
          </div>
        </div>

        {/* Paid Uses */}
        <div>
          <div className="text-sm text-white/80 mb-2">Paid Uses</div>
          <div className="text-3xl font-bold text-white">
            {paidUses || 0}
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-center gap-4">
        <Button 
          onClick={() => navigate('/user_dashboard')}
          className="bg-white/20 hover:bg-white/30 text-white border border-white/20 px-6 py-3 rounded-lg flex items-center gap-2"
        >
          📊 View Transaction History
        </Button>
        <Button 
          onClick={onCreateNew}
          className="bg-white/20 hover:bg-white/30 text-white border border-white/20 px-6 py-3 rounded-lg flex items-center gap-2"
        >
          {icon} Create New {serviceCode}
        </Button>
      </div>
    </div>
  );
};

export default ServiceDashboardHeader;
